import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

const fpingSignupForm = function (classname, form) {
  const $form = $(form);
  const signUpApiUrl = $form.data('signup-url') || 'https://api.freshping.io/v1/signup/';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const email = $form.find('input[name^=email]').val();
  const url = $form.find('input[name^=url]').val();
  const planName = SiteUtilities.getParameterByName('plan');

  const data = {
    email: email,
    application_url: url
  };

  if (planName !== '') {
    data['custom_ui_state'] = JSON.stringify({
      plan_name: planName
    });
  }

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: (response) => {
      fpingSignupFormSuccess($form, response);
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      var errorMessage = 'Backend error';
      if (xhr.responseJSON) {
        if (xhr.responseJSON.non_field_errors) {
          $form.addClass('error');
          errorMessage = xhr.responseJSON.non_field_errors.join(', ');
        } else if (xhr.responseJSON.email) {
          $('.' + classname + ' input[name^=email]').parents('.form-field').addClass('error');
          errorMessage = xhr.responseJSON.email.join(', ');
        } else if (xhr.responseJSON.application_url) {
          $('.' + classname + ' input[name^=url]').parents('.form-field').addClass('error');
          errorMessage = xhr.responseJSON.application_url.join(', ');
        }
      }
      $form.find('.error-wrapper').empty().append('<em class="error">' + errorMessage + '</em>');
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

const fpingSignupFormSuccess = function ($form, response, alohaV2 = false) {
  const email = $form.find('input[name^=email]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const redirect = $form.attr('data-redirect');
  const url = $form.find('input[name^=url]').val();
  const errorWrapper = $form.find('.other-errors-wrapper');
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();

  SiteUtilities.configureAssetId($form, 'fping');
  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      email: email,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fpingfirstreferrer: Cookie.get('fw_flu') || '',
        cf_fpingsignupreferrer: window.location.href || '',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  errorWrapper.removeClass('error');

  let redirectUrl;
  let accountId = '';
  let thankyouParams = '';
  if (alohaV2) {
    const signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : '';
  } else {
    const organizationId = response.organization_id || '';
    const userId = response.user_id || '';
    thankyouParams = `&organisation_id=${organizationId}&user_id=${userId}`;
    redirectUrl = response.token_login_url;
  }
  freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
  freshmarketerData.freshmarketerObject.product = 'Freshping';
  freshmarketerData.freshmarketerObject.accountId = accountId;
  localStorage.setItem('redirect_url', redirectUrl);
  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshping');
  SiteUtilities.freshmarketerPost(freshmarketerData, false, $form).then(function () {
    localStorage.setItem('fmarketerEndTime', new Date().toISOString());
    jQuery('body').trigger('trackingCompleted');
  });
  jQuery('body').on('trackingCompleted', () => {
    // Addimg 1.5s to timstamp since the redirect happens after a timeout of 1500ms
    localStorage.setItem('thankyouRedirectStartTime', new Date(new Date().getTime() + 1500).toISOString());
    setTimeout(() => {
      let thankYouRedirect = `${redirect}/?url=${encodeURIComponent(url)}&ehash=${emailHash}${thankyouParams}`;
      if (isExternalIframeSignup) {
        thankYouRedirect += '&post_to_partner=true';
        if (currentReferrer) {
          thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
        }
      }
      window.location.href = thankYouRedirect;
    }, 1500);
  });
};

const fpingLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('input.domain-form').val();
  $form.find('input.domain-form').parents('.form-field').removeClass('error');
  const domainAvailableUrl = 'https://api.freshping.io/v1/domain_available?domain=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  $.getJSON(domainAvailableUrl + domain, function (data) {
    if (!data.available) {
      window.location.href = 'https://' + domain + '.freshping.io';
    } else {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.domain-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').append("<em class='error'>This account does not exist</em>");
    }
  }).fail(function () {
    $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    $form.find('.domain-form').parents('.form-field').addClass('error');
    $form.find('.error-wrapper').append("<em class='error'>Error contacting the api</em>");
  });
  GA4Utilities.loginFormSubmit(domain);
};

const fpingForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://api.freshping.io/v1/forgot_domain?email=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email),
    type: 'GET',
    success: (response) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      if (response && response.sent_email) {
        jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
        setTimeout(function () {
          jQuery('.forgot-domain-success').slideDown(300);
        }, 300);
      } else {
        $form.find('.email-form').parents('.form-field').addClass('error');
        $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
      }
    },
    error: (xhr, status, err) => {
      const errorMsg = (xhr.responseText === '"User with email does not exists"') ? xhr.responseText : 'Error contacting the api';
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append(`<em class='error'>${errorMsg}</em>`);
    }
  });
};

export default {
  fpingSignupForm,
  fpingLoginForm,
  fpingForgotDomainForm,
  fpingSignupFormSuccess
};
